import { Form, Formik, FieldArray } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
// import shareadduser from "../../../assets/images/shareadduser.svg";
import addcircle from "../../../assets/images/add-circle.svg";
import cross from "../../../assets/images/01_icon.svg";
import { initialValues } from "./inviteOnlyInitialValues";
import ShareDocumentmodal from "./modal/ShareDocumentModal";
import ShareDocumentAccessModal from "./modal/ShareDocumentAccessModal";
import Fields from "../../form-components/Fields";
import { useDispatch, useSelector } from "react-redux";
import { getLabels } from "../../../features/chatbot/labelListSlice";
import { getDocuments } from "../../../features/user-document/documentListingSlice";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { inviteOnly } from "../../../features/chatbot/inviteOnlySlice";
import { getProjectPermission } from "../../../features/project-permission/getProjectPermissionSlice";

const InviteOnlyFormComponent = ({
  setPublicShareShow,
  setCurrentRadio,
  currentRadio,
  inviteOnlyData,
}) => {
  const {
    documentListData = null,
    labelList = null,
    total_records,
  } = useSelector((state) => ({
    documentListData: state?.documentListing?.documentListing,
    labelList: state?.getLabelReducer?.labelList,
    total_records: state?.documentListing?.totalCount,
  }));

  const [documentData, setDocumentData] = useState([]);
  const [currentModal, setCurrentModal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedLabelOptions, setSelectedLabelOptions] = useState([]);
  const [selectedType, setSelectedType] = useState("user");
  const [selectedData, setSelectedData] = useState([]);
  const [selectedtypeSearch, setSelectedTypeSearch] = useState("");
  const [isAllChecked, setIsAllChecked] = useState(false);

  const hasMoreSitter = currentPage * 10 < total_records;

  const documentFilterOptions = [];
  documentListData &&
    documentData?.map((document) => {
      documentFilterOptions.push({
        label: document.title,
        value: document.uuid,
      });
    });

  const labelFilterOptions = [];
  labelList &&
    labelList?.labels?.map((label) => {
      labelFilterOptions.push({ label: label.name, value: label.uuid });
    });

  let projectData = JSON.parse(localStorage.getItem("_user"));

  const dispatch = useDispatch();

  useEffect(() => {
    getDocumentList();
    dispatch(getLabels(projectData?.projects[0]?.slug));
  }, []);

  const getDocumentList = (pageNumber = 1) => {
    let documents;
    dispatch(
      getDocuments({
        perPage: 10,
        page: pageNumber,
        project_uuid: projectData?.projects[0]?.uuid,
      })
    ).then((data) => {
      documents = data?.payload?.data?.data?.documents;
      setDocumentData([...documentData, ...documents]);
    });
  };

  const AcessName = [
    {
      label: "Rehana",
      value: "Rehana",
    },
    {
      label: "Mily",
      value: "Mily",
    },
    {
      label: "Jhone Doe",
      value: "Jhone Doe",
    },
  ];

  /**
   * entity options
   */
  const EntireProject = [
    {
      label: "Entire Project",
      value: 3,
    },
    {
      label: "Specific Documents",
      value: 1,
    },
    {
      label: "Specific Labels",
      value: 2,
    },
  ];

  /**
   * handle invite only change function
   * @param {*} e
   */
  const handleInviteChange = (e) => {
    setCurrentRadio("inviteOnly");
    /* setInviteCheck(e.target.checked) */
    /* setInviteChange(true); */
    setPublicShareShow(false);
  };

  /**
   * handle permission entity change function
   * @param {*} e
   */
  // const handleEntityChange = (e) => {
  //   console.log(e?.value);
  //   setPermissionEntity(e?.value)
  // }

  /**
   * submit function for invite only functionality
   */
  const inviteOnlySubmit = async (values) => {
    let formData = {};
    formData.inviteOnly = values.inviteOnly;
    formData.project_uuid = projectData?.projects[0]?.uuid;
    // values?.inviteOnly?.length > 0 && values?.inviteOnly?.map((inviteData) => {
    //   if (inviteData.entity === "3") {
    //     inviteData.project_uuid = projectData?.projects[0]?.uuid;
    //     return inviteData;
    //   }
    //   return inviteData;
    // })
    await dispatch(inviteOnly(formData));
    dispatch(
      getProjectPermission(
        JSON.parse(localStorage.getItem("_user")).projects[0].uuid
      )
    );
  };

  /**
   * modal close/open function
   */
  const toggleModal = (setFieldValue, index) => {
    setCurrentModal("");
    // setFieldValue(`inviteOnly[${index}].access_user`, []);
    // setFieldValue(`inviteOnly[${index}].access_role`, []);
    setSelectedData([]);
    setIsAllChecked(false);
  };

  const onSaveAccessClick = () => {
    setCurrentModal("");
    setSelectedData([]);
    setIsAllChecked(false);
    setSelectedType("user");
  };

  /**
   * custom dropdown for label, document, roles
   * @returns
   */
  // const CustomDrodown = ({ newIndex }) => {
  //   return (
  //     <>
  //       <div className="name-main">
  //         <button type="button" className="btn">+3</button>
  //         <div className="dropdown-menu">
  //           <ul>
  //             <li key={i} className="dropdown-item">{d?.name}</li>
  //             <li className="dropdown-item">Sam Kenial</li>
  //             <li className="dropdown-item">Olivia Rig</li>
  //           </ul>
  //         </div>
  //       </div>
  //     </>
  //   );
  // }

  function onChange(
    value,
    event,
    setFieldValue,
    formikFieldName,
    formikIndex,
    options
  ) {
    if (event.action === "select-option" && event.option.value === "*") {
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_labels`,
        options
      );
      setSelectedLabelOptions(options);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      setFieldValue(`${formikFieldName}[${formikIndex}].specific_labels`, []);
      setSelectedLabelOptions([]);
    } else if (event.action === "deselect-option") {
      setSelectedLabelOptions(value.filter((o) => o.value !== "*"));
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_labels`,
        value.filter((o) => o.value !== "*")
      );
    } else if (value?.length === options?.length - 1) {
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_labels`,
        options
      );
      setSelectedLabelOptions(options);
    } else {
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_labels`,
        value
      );
      setSelectedLabelOptions(value);
    }
  }

  function documentChange(
    value,
    event,
    setFieldValue,
    formikFieldName,
    formikIndex,
    options
  ) {
    if (event.action === "select-option" && event.option.value === "*") {
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_documents`,
        options
      );
      setSelectedOptions(options);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_documents`,
        []
      );
      setSelectedOptions([]);
    } else if (event.action === "deselect-option") {
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_documents`,
        value.filter((o) => o.value !== "*")
      );
      setSelectedOptions(value.filter((o) => o.value !== "*"));
    } else if (value?.length === options?.length - 1) {
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_documents`,
        options
      );
      setSelectedOptions(options);
    } else {
      setFieldValue(
        `${formikFieldName}[${formikIndex}].specific_documents`,
        value
      );
      setSelectedOptions(value);
    }
  }

  const doLoadMoreData = () => {
    let numberPage = currentPage + 1;
    hasMoreSitter && getDocumentList(numberPage);
    setCurrentPage(numberPage);
  };

  const onAccessClick = (index) => {
    setCurrentModal(`AccessModal${index}`);
  };

  return (
    <>
      <Formik
        initialValues={
          inviteOnlyData?.inviteOnly?.length > 0
            ? inviteOnlyData
            : initialValues
        }
        // initialValues={initialValues}
        validationSchema={""}
        onSubmit={inviteOnlySubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          touched,
          errors,
          isSubmitting,
          handleSubmit,
          setFieldValue,
        }) => {
          return (
            <Form>
              <FieldArray name="inviteOnly">
                {({ insert, remove, push }) => (
                  <>
                    {/* <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        checked={"inviteOnly" === currentRadio}
                        onChange={(e) => { handleInviteChange(e) }}
                        name="privateShare"
                        id="flexRadioDefault4"
                      />
                      <label className="form-check-label" htmlFor="flexRadioDefault4">
                        <div className="d-flex align-items-start flex-md-row flex-column">
                          <div className="radio-label-div pe-md-3">
                            <p>Invite-Only</p>
                            <p>
                              Only people who are explicitly invited can see this project.
                            </p>
                          </div>
                          <button type="submit" className="btn ms-0 mt-3 ms-md-5 mt-md-1" onClick={inviteOnlySubmit}>
                            <img src={shareadduser} alt="shareadduser" className="sh-invite-img" />
                            Start Inviting
                          </button>
                        </div>
                      </label>
                      {currentRadio === "inviteOnly" &&
                        (
                          <> */}
                    <div className="radio-label-div pe-md-3 pt-2 pt-md-2">
                      <p className="fw-500">Permissions</p>
                    </div>
                    {values?.inviteOnly?.length > 0 &&
                      values?.inviteOnly?.map((inviteOnlydata, index) => (
                        <div
                          key={index}
                          className="share-react-slect mt-1 pt-md-1"
                        >
                          <div className="d-flex flex-column flex-md-row">
                            <div className="spcify-doc cmn-doc-slect">
                              <div className="radio-label-div">
                                <p>Entity</p>
                              </div>
                              <Select
                                id="inputGroupSelect01"
                                name={`inviteOnly[${index}].entity`}
                                options={EntireProject}
                                defaultValue={{
                                  label: "Entire Project",
                                  value: 3,
                                }}
                                value={{
                                  value: values?.inviteOnly[index].entity,
                                  label:
                                    values?.inviteOnly[index].entity === 1
                                      ? "Specific Documents"
                                      : values?.inviteOnly[index].entity === 2
                                      ? "Specific Labels"
                                      : "Entire Project",
                                }}
                                onChange={(e) => {
                                  setFieldValue(
                                    `inviteOnly[${index}].entity`,
                                    e.value
                                  );
                                }}
                                placeholder="Select Entity"
                                classNamePrefix="cmn-control"
                                // menuIsOpen={true}
                              />
                            </div>
                            <div className="first-pro cmn-doc-slect">
                              <div className="radio-label-div">
                                <p>Name</p>
                              </div>
                              {values?.inviteOnly[index].entity === 1 && (
                                // <div className="share-name-control onlyfor-long-link" onClick={() => { setCurrentModal("shareDocumentModal") }}>
                                //   <div className="name-btn text-start">
                                //     <span className="btn-txt">My First Project</span>
                                //     <CustomDrodown />
                                //     <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg">
                                //       <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                                //     </svg>
                                //   </div>
                                // </div>
                                <div className="cmn-share-multi">
                                  <ReactMultiSelectCheckboxes
                                    options={[
                                      { label: "Select ALL", value: "*" },
                                      ...documentFilterOptions,
                                    ]}
                                    // getDropdownButtonLabel={getDropdownButtonDocument}
                                    value={
                                      values?.inviteOnly[index]
                                        .specific_documents
                                    }
                                    // value={selectedOptions}
                                    onChange={(value, event) =>
                                      documentChange(
                                        value,
                                        event,
                                        setFieldValue,
                                        "inviteOnly",
                                        index,
                                        [
                                          { label: "Select ALL", value: "*" },
                                          ...documentFilterOptions,
                                        ]
                                      )
                                    }
                                    // setState={setSelectedOptions}
                                    onMenuScrollToBottom={() =>
                                      doLoadMoreData()
                                    }
                                    name={`inviteOnly[${index}].specific_documents`}
                                    className="cmn-control"
                                    classNamePrefix="cmn-control"
                                  />
                                </div>
                              )}
                              {values?.inviteOnly[index].entity === 2 && (
                                // <div className="share-name-control onlyfor-long-link" onClick={() => { setCurrentModal("shareDocumentModal") }}>
                                //   <div className="name-btn text-start">
                                //     <span className="btn-txt">My First Project</span>
                                //     <CustomDrodown />
                                //     <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg">
                                //       <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                                //     </svg>
                                //   </div>
                                // </div>
                                <div className="cmn-share-multi">
                                  <ReactMultiSelectCheckboxes
                                    options={[
                                      { label: "Select ALL", value: "*" },
                                      ...labelFilterOptions,
                                    ]}
                                    // getDropdownButtonLabel={getDropdownButtonDocument}
                                    value={
                                      values?.inviteOnly[index].specific_labels
                                    }
                                    // value={selectedLabelOptions}
                                    onChange={(value, event) =>
                                      onChange(
                                        value,
                                        event,
                                        setFieldValue,
                                        "inviteOnly",
                                        index,
                                        [
                                          { label: "Select ALL", value: "*" },
                                          ...labelFilterOptions,
                                        ]
                                      )
                                    }
                                    // setState={setSelectedLabelOptions}
                                    name={`inviteOnly[${index}].specific_labels`}
                                    className="cmn-control"
                                    classNamePrefix="cmn-control"
                                  />
                                </div>
                              )}
                              {values?.inviteOnly[index].entity === 3 && (
                                <div className="myproject-name-control">
                                  <Fields
                                    type="text"
                                    value={`${values?.inviteOnly[index].entity_name}`}
                                    name={`inviteOnly.${index}.entity_name`}
                                    onChange={handleChange}
                                    className="form-control"
                                  />
                                </div>
                              )}
                            </div>
                            <div className="access-dropdown cmn-doc-slect">
                              <div className="radio-label-div">
                                <p>Access</p>
                              </div>
                              <div className="position-relative">
                                <div
                                  className="share-name-control access-name-control"
                                  onClick={() => {
                                    onAccessClick(index);
                                  }}
                                >
                                  <div className="name-btn text-start pe-2">
                                    <span className="btn-txt">
                                      {values?.inviteOnly[index].access_user
                                        .length > 0
                                        ? values?.inviteOnly[index]
                                            .access_user === "All"
                                          ? "All"
                                          : values?.inviteOnly[index]
                                              .access_user.length
                                        : values?.inviteOnly[index]
                                            .access_role === "All"
                                        ? "All"
                                        : values?.inviteOnly[index].access_role
                                            .length}{" "}
                                      Selected
                                    </span>
                                    {/* <CustomDrodown selectedNumber={values?.inviteOnly[index].access.length} /> */}
                                    <svg
                                      height="20"
                                      width="20"
                                      viewBox="0 0 20 20"
                                      aria-hidden="true"
                                      focusable="false"
                                      className="css-tj5bde-Svg"
                                    >
                                      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                                    </svg>
                                  </div>
                                </div>
                                {index + 1 === values?.inviteOnly?.length && (
                                  <button
                                    type="button"
                                    className="btn add-circle p-0 border-0"
                                  >
                                    <img
                                      src={addcircle}
                                      alt="addcircle"
                                      onClick={() =>
                                        push({
                                          entity: 3,
                                          entity_name: "",
                                          access_user: [],
                                          access_role: [],
                                          specific_documents: [],
                                          specific_labels: [],
                                        })
                                      }
                                    />
                                  </button>
                                )}
                                {index + 1 !== values?.inviteOnly?.length && (
                                  <button
                                    type="button"
                                    className="btn add-circle p-0 border-0"
                                  >
                                    <img
                                      src={cross}
                                      alt="addcircle"
                                      onClick={() => remove(index)}
                                    />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                          {currentModal === `AccessModal${index}` && (
                            <ShareDocumentAccessModal
                              isOpen={currentModal === `AccessModal${index}`}
                              toggle={() => toggleModal(setFieldValue, index)}
                              selectedType={selectedType}
                              setSelectedType={setSelectedType}
                              selectedData={selectedData}
                              setSelectedData={setSelectedData}
                              selectedtypeSearch={selectedtypeSearch}
                              setSelectedTypeSearch={setSelectedTypeSearch}
                              values={values}
                              index={index}
                              setFieldValue={setFieldValue}
                              onSaveAccessClick={onSaveAccessClick}
                              isAllChecked={isAllChecked}
                              setIsAllChecked={setIsAllChecked}
                              inviteOnlyData={inviteOnlyData}
                            />
                          )}
                        </div>
                      ))}
                    {/* </>
                        )}
                    </div> */}
                  </>
                )}
              </FieldArray>
              <div className="text-end mt-4">
                <button
                  type="button"
                  className="btn btn-primary-md"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
      {/* {currentModal === "shareDocumentModal" &&
        <ShareDocumentmodal
          isOpen={currentModal === "shareDocumentModal"}
          toggle={toggleModal}
          setSpecificDocuments={setSpecificDocuments}
        />
      } */}
    </>
  );
};

export default InviteOnlyFormComponent;
